import Reveal from "./Reveal";
import { Heart, MapPin, Phone } from "lucide-react";

const OWNER_PHOTO =
  "https://customer-assets.emergentagent.com/job_cargides-facelift/artifacts/fae7lfr8_Portret%20gilles%20en%20justine.png";

const TEAM = [
  {
    name: "Gilles Descamps",
    role: "Oprichter",
    title: "CEO",
    phone: "+32 496 61 46 38",
    phoneRaw: "+32496614638",
    photo: "/team/gilles.jpg",
  },
  {
    name: "Justine Verbeke",
    role: "Co-founder",
    title: "Sales & Operations",
    phone: "+32 490 26 55 88",
    phoneRaw: "+32490265588",
    photo: "/team/justine.jpg",
  },
];

export default function Owners() {
  return (
    <section
      id="over-ons"
      data-testid="owners-section"
      className="relative bg-white py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Photo */}
          <Reveal className="lg:col-span-6 relative" data-testid="owners-photo-wrap">
            <div className="relative aspect-square w-full overflow-hidden bg-cgsurface">
              <img
                src={OWNER_PHOTO}
                alt="Gilles en Justine, eigenaars Cargides Group"
                className="absolute inset-0 w-full h-full object-cover"
                data-testid="owners-photo"
              />
              <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-cgprimary z-0 hidden md:block" />
              <div className="absolute top-5 left-5 bg-white px-3 py-1.5 text-[10px] font-bold tracking-[0.2em] uppercase text-cgdark">
                Sinds 2019
              </div>
            </div>
            <div className="hidden lg:flex absolute -bottom-6 -left-6 bg-cgdark text-white px-6 py-5 z-10 items-center gap-4">
              <Heart size={20} className="text-cgprimary" strokeWidth={1.5} />
              <div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-white/60">
                  Familiebedrijf
                </div>
                <div className="font-heading text-lg font-semibold">Gilles & Justine</div>
              </div>
            </div>
          </Reveal>

          {/* Story */}
          <div className="lg:col-span-6">
            <Reveal>
              <p className="eyebrow mb-5" data-testid="owners-eyebrow">Over ons</p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight text-cgdark mb-8">
                De gezichten <br />
                <span className="italic font-light">achter</span>{" "}
                <span className="text-cgprimary">Cargides Group.</span>
              </h2>
            </Reveal>

            <Reveal delay={120}>
              <p className="text-cgmuted text-base md:text-lg leading-relaxed mb-6">
                Wij zijn <strong className="text-cgdark">Gilles Descamps en Justine Verbeke</strong>. Sinds 2019 bouwen we vanuit Wevelgem aan Cargides Group, een mobiele wash-dienst die we begonnen vanuit één eenvoudige gedachte: bedrijven verdienen een vloot die er steeds piekfijn bij staat, zonder dat ze er een dag voor uitvallen.
              </p>
              <p className="text-cgmuted text-base md:text-lg leading-relaxed mb-10">
                Wat klein begon, groeide uit tot een gepassioneerd team dat elke maand honderden wagens een tweede leven geeft. Persoonlijk contact, eerlijk werk en oog voor detail blijven onze handtekening, bij iedere klant, iedere wagen, iedere wash.
              </p>
            </Reveal>

            <Reveal delay={200} className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-cgborder border border-cgborder">
              {TEAM.map((m, i) => (
                <div key={m.name} className="bg-white p-6" data-testid={`owner-card-${i}`}>
                  <div className="flex items-center gap-4 mb-4">
                    <img
                      src={m.photo}
                      alt={m.name}
                      className="w-14 h-14 rounded-full object-cover border border-cgborder"
                      data-testid={`owner-photo-${i}`}
                    />
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.2em] text-cgprimary font-semibold">
                        {m.role}
                      </div>
                      <div className="font-heading text-lg font-semibold text-cgdark leading-tight">
                        {m.name}
                      </div>
                      <div className="text-cgmuted text-xs mt-0.5">{m.title}</div>
                    </div>
                  </div>
                  <a
                    href={`tel:${m.phoneRaw}`}
                    className="flex items-center gap-2 text-cgdark hover:text-cgprimary transition-colors text-sm font-semibold link-underline w-fit"
                    data-testid={`owner-phone-${i}`}
                  >
                    <Phone size={14} className="text-cgprimary" />
                    {m.phone}
                  </a>
                </div>
              ))}
            </Reveal>

            <Reveal delay={280}>
              <div className="mt-10 flex items-center gap-3 text-cgmuted">
                <MapPin size={18} className="text-cgprimary" strokeWidth={1.5} />
                <span className="text-sm">Wevelgem, West-Vlaanderen. Actief in heel België.</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
